import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ExternalLink } from "lucide-react";

const REFERENCES = [
  {
    label: "Benedé-Ubieto et al., 2024. Gut Microbes",
    url: "https://pubmed.ncbi.nlm.nih.gov/38512763/",
  },
  {
    label: "Lu et al., 2025. Current Research in Food Science",
    url: "https://pubmed.ncbi.nlm.nih.gov/40697756/",
  },
  {
    label: "Wu et al., 2024. Clinics and Research in Hepatology and Gastroenterology",
    url: "https://pubmed.ncbi.nlm.nih.gov/38879003/",
  },
];

export function GutLiverAxisSection() {
  return (
    <section
      aria-labelledby="gut-liver-axis-heading"
      className="mt-10 md:mt-16"
    >
      <div className="mx-auto max-w-3xl">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[0.22em] text-brand">
          Science · Education
        </p>
        <h2
          id="gut-liver-axis-heading"
          className="mt-2 text-center font-display text-3xl font-bold text-brand-deep md:text-4xl"
        >
          The Gut-Liver Axis and Metabolic Wellness
        </h2>

        <div className="mt-6 space-y-4 text-[15px] leading-relaxed text-foreground/85 md:text-base">
          <p>
            Emerging research on the gut-liver axis suggests that supporting a
            balanced gut microbiota and healthy intestinal barrier function may
            help maintain healthy liver enzyme levels and metabolic balance,
            especially when paired with nutrition, movement, weight management,
            sleep, and other healthy lifestyle measures.
          </p>
          <p>
            Truwe is designed to support everyday gut and metabolic wellness as
            part of a healthy lifestyle. It is not intended to diagnose, treat,
            cure, or prevent liver disease.
          </p>
        </div>


        <div className="mt-6">
          <Accordion type="single" collapsible className="rounded-2xl border border-border bg-card">
            <AccordionItem value="references" className="border-b-0">
              <AccordionTrigger className="px-5 py-3 text-left text-[13px] font-semibold uppercase tracking-[0.14em] text-brand-deep hover:no-underline">
                References
              </AccordionTrigger>
              <AccordionContent className="px-5 pb-4">
                <ul className="space-y-2 text-[13px] text-foreground/80">
                  {REFERENCES.map((r) => (
                    <li key={r.url}>
                      <a
                        href={r.url}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-start gap-1.5 text-brand hover:underline"
                      >
                        <span>{r.label}</span>
                        <ExternalLink className="mt-0.5 h-3 w-3 flex-shrink-0" />
                      </a>
                    </li>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </section>
  );
}
